import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useMailAdminAuth } from '../../hooks/useMailAdminAuth'

export function AdminLogin() {
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const { login } = useMailAdminAuth()
  const navigate = useNavigate()

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')
    setLoading(true)

    try {
      const ok = await login(username, password)
      if (ok) {
        navigate('/admin/domains')
      } else {
        setError('Invalid credentials')
      }
    } catch {
      setError('Connection failed — is the admin backend running?')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-100">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <svg viewBox="0 0 50 50" fill="none" className="w-12 h-12 mx-auto mb-4">
            <defs>
              <linearGradient id="shieldGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" style={{ stopColor: '#1B3A5C' }} />
                <stop offset="100%" style={{ stopColor: '#0F2640' }} />
              </linearGradient>
            </defs>
            <path d="M25 5 L40 12 L40 26 C40 36 34 43 25 47 C16 43 10 36 10 26 L10 12 Z" fill="url(#shieldGrad)" />
            <rect x="16" y="18" width="18" height="13" rx="2" fill="#E2E8F0" />
            <path d="M16 18 L25 25 L34 18" fill="#2A5580" />
          </svg>
          <h1 className="font-display text-2xl font-bold text-text">envelo admin</h1>
          <p className="text-sm text-text-muted mt-1">Server administration panel</p>
        </div>

        <form onSubmit={handleSubmit} className="bg-surface rounded-xl border border-slate-200 p-8 space-y-4">
          {error && (
            <div className="px-4 py-3 rounded-lg bg-red-50 border border-red-200 text-sm text-red-700">
              {error}
            </div>
          )}

          <div>
            <label className="block text-sm font-medium text-text mb-1">Username</label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="w-full px-3 py-2.5 border border-slate-200 rounded-lg text-sm focus:outline-none focus:border-sovereign-500 focus:ring-2 focus:ring-sovereign-500/20"
              autoFocus
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-text mb-1">Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-3 py-2.5 border border-slate-200 rounded-lg text-sm focus:outline-none focus:border-sovereign-500 focus:ring-2 focus:ring-sovereign-500/20"
              required
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full py-2.5 bg-sovereign-600 text-white rounded-lg font-medium text-sm hover:bg-sovereign-700 transition-colors disabled:opacity-50"
          >
            {loading ? 'Signing in...' : 'Sign in'}
          </button>
        </form>
      </div>
    </div>
  )
}
